import styled, { css } from "styled-components";

export const getTextColor = ({ isSelected = false, isDisabled = false }) => {
  if (isDisabled) return "var(--Gray)";
  if (isSelected) return "var(--MainBlue)";
  return "var(--DarkNavy)";
};

const TextBase = styled.p`
  margin: 0;
  padding: 0;
  color: ${({ color }) => color ?? "inherit"};
  cursor: ${({ onClick }) => (onClick ? "pointer" : "inherit")};
`;

export const textStyleHeading1 = css`
  font-size: var(--fontSize-28);
  font-weight: var(--fontWeight-700);
  line-height: 100%;
  letter-spacing: 0rem;
`;
export const textStyleHeading2 = css`
  font-size: var(--fontSize-26);
  font-weight: var(--fontWeight-600);
  line-height: 100%;
  letter-spacing: 0rem;
`;
export const textStyleHeading3 = css`
  font-size: var(--fontSize-24);
  font-weight: var(--fontWeight-600);
  line-height: 100%;
  letter-spacing: 0rem;
`;

export const textStyleTitle1 = css`
  font-size: var(--fontSize-22);
  font-weight: var(--fontWeight-600);
  line-height: 100%;
  letter-spacing: 0rem;
`;
export const textStyleTitle2 = css`
  font-size: var(--fontSize-20);
  font-weight: var(--fontWeight-600);
  line-height: 100%;
  letter-spacing: 0rem;
`;
export const textStyleTitle3 = css`
  font-size: var(--fontSize-18);
  font-weight: var(--fontWeight-500);
  line-height: 100%;
  letter-spacing: 0rem;
`;
export const textStyleTitle4 = css`
  font-size: var(--fontSize-16);
  font-weight: var(--fontWeight-700);
  line-height: 100%;
  letter-spacing: 0rem;
`;

export const textStyleMenu = css`
  font-size: var(--fontSize-14);
  font-weight: var(--fontWeight-400);
  line-height: 100%;
  letter-spacing: 0rem;
`;
export const textStyleSelection = css`
  font-size: var(--fontSize-16);
  font-weight: var(--fontWeight-400);
  line-height: 100%;
  letter-spacing: 0rem;
`;

export const textStyleBody1 = css`
  font-size: var(--fontSize-16);
  font-weight: var(--fontWeight-400);
  line-height: 140%;
  letter-spacing: -0.02rem;
`;
export const textStyleBody2 = css`
  font-size: var(--fontSize-14);
  font-weight: var(--fontWeight-400);
  line-height: 140%;
  letter-spacing: -0.02rem;
`;
export const textStyleBody3 = css`
  font-size: var(--fontSize-14);
  font-weight: var(--fontWeight-600);
  line-height: 140%;
  letter-spacing: -0.02rem;
`;

export const textStyleLabel = css`
  font-size: var(--fontSize-14);
  font-weight: var(--fontWeight-700);
  line-height: 100%;
  letter-spacing: 0rem;
`;

export const textStylePlaceholder = css`
  font-size: var(--fontSize-14);
  font-weight: var(--fontWeight-400);
  line-height: 100%;
  letter-spacing: 0rem;
`;

export const textStyleButton1 = css`
  font-size: var(--fontSize-16);
  font-weight: var(--fontWeight-600);
  line-height: 100%;
  letter-spacing: 0rem;
`;
export const textStyleButton2 = css`
  font-size: var(--fontSize-14);
  font-weight: var(--fontWeight-600);
  line-height: 100%;
  letter-spacing: 0rem;
`;
export const textStyleButton3 = css`
  font-size: var(--fontSize-11);
  font-weight: var(--fontWeight-400);
  line-height: 100%;
  letter-spacing: 0rem;
`;

export const textStyleBadge = css`
  font-size: var(--fontSize-12);
  font-weight: var(--fontWeight-400);
  line-height: 100%;
  letter-spacing: 0rem;
`;

export const textStyleNote1 = css`
  font-size: var(--fontSize-12);
  font-weight: var(--fontWeight-400);
  line-height: 120%;
  letter-spacing: 0rem;
`;
export const textStyleNote2 = css`
  font-size: var(--fontSize-10);
  font-weight: var(--fontWeight-400);
  line-height: 120%;
  letter-spacing: 0rem;
`;

export const TextHeading1 = styled(TextBase)`
  ${textStyleHeading1}
`;
export const TextHeading2 = styled(TextBase)`
  ${textStyleHeading2}
`;
export const TextHeading3 = styled(TextBase)`
  ${textStyleHeading3}
`;

export const TextTitle1 = styled(TextBase)`
  ${textStyleTitle1}
`;
export const TextTitle2 = styled(TextBase)`
  ${textStyleTitle2}
`;
export const TextTitle3 = styled(TextBase)`
  ${textStyleTitle3}
`;
export const TextTitle4 = styled(TextBase)`
  ${textStyleTitle4}
`;

export const TextMenu = styled(TextBase)`
  ${textStyleMenu}
`;
export const TextSelection = styled(TextBase)`
  ${textStyleSelection}
`;

export const TextBody1 = styled(TextBase)`
  ${textStyleBody1}
`;
export const TextBody2 = styled(TextBase)`
  ${textStyleBody2}
`;
export const TextBody3 = styled(TextBase)`
  ${textStyleBody3}
`;

export const TextLabel = styled(TextBase)`
  ${textStyleLabel}
`;
export const TextPlaceholder = styled(TextBase)`
  ${textStylePlaceholder}
`;

export const TextButton1 = styled(TextBase)`
  ${textStyleButton1}
`;
export const TextButton2 = styled(TextBase)`
  ${textStyleButton2}
`;
export const TextButton3 = styled(TextBase)`
  ${textStyleButton3}
`;

export const TextBadge = styled(TextBase)`
  ${textStyleBadge}
`;

export const TextNote1 = styled(TextBase)`
  ${textStyleNote1}
`;
export const TextNote2 = styled(TextBase)`
  ${textStyleNote2}
`;

//
//
//
//
//
//
//
//TODO:delete later
const TitleTextStyle = styled.div`
  font-size: var(--fontSize-32);
  font-weight: var(--fontWeight-700);
  color: var(--DarkNavy);
`;

const ContentTextStyle = styled.div`
  font-size: var(--fontSize-20);
  font-weight: var(--fontWeight-400);
`;

const PageTitleTextStyle = styled.div`
  font-size: var(--fontSize-20);
  font-weight: var(--fontWeight-700);
  color: var(--DarkNavy);
  white-space: nowrap;
`;

const PageSubTitleTextStyle = styled.div`
  font-size: var(--fontSize-20);
  font-weight: var(--fontWeight-700);
  color: Black;
  white-space: nowrap;
`;

const FieldTitleTextStyle = styled.div`
  font-size: var(--fontSize-14);
  font-weight: var(--fontWeight-700);
  color: var(--DarkNavy);

  display: flex;
  display-direction: row;
  justify-content: flex-start;
  gap: 0.2rem;
  align-items: center;
`;

const BlueTitleTextStyle = styled.div`
  font-size: var(--fontSize-16);
  font-weight: var(--fontWeight-700);
  color: var(--MainBlue);
`;

const BlackTitleTextStyle = styled.div`
  font-size: var(--fontSize-16);
  font-weight: var(--fontWeight-700);
  color: var(--Black);
  margin-bottom: 1rem;
`;

export {
  TitleTextStyle,
  ContentTextStyle,
  PageTitleTextStyle,
  PageSubTitleTextStyle,
  FieldTitleTextStyle,
  BlueTitleTextStyle,
  BlackTitleTextStyle,
};
